import { InjectionToken } from "@angular/core";

export const EMOJI_PATH = new InjectionToken<string>('EMOJI_PATH');